/* cwclientelements
   copyright 2019 LOGILAB S.A. (Paris, FRANCE), all rights reserved.
   contact http://www.logilab.fr/ -- mailto:contact@logilab.fr
*/

import {
    EntityRelationsGroupProps,
    EntityRelationsGroup,
    ENTITY_RELATIONS_GROUP_DEFAULT_PROPS,
} from './EntityRelationsGroup';

/**
 * Default component for rendering a group of relations with the same name on an entity
 */
export class DefaultEntityRelationsGroup extends EntityRelationsGroup<EntityRelationsGroupProps> {
    public static defaultProps = ENTITY_RELATIONS_GROUP_DEFAULT_PROPS;

    render(): JSX.Element {
        return this.props.render(this);
    }
}
